if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Show minimum quantity message on load
        this.showMinimumQuantityMessage();
        this.listenForCartUpdates();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        // Update button text to "Adding..."
        const buttonText = this.submitButton.querySelector('.card__cta-text') || this.submitButtonText;
        if (buttonText) {
          const originalText = buttonText.textContent;
          buttonText.setAttribute('data-original-text', originalText);
          buttonText.textContent = 'Adding...';
        }

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Try to find cart element if not already found
        if (!this.cart) {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Try to find cart element again after successful add
              this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

              // If still no cart drawer/notification, just update cart count in header
              if (!this.cart) {
                // Update cart count in header
                fetch('/cart.js')
                  .then(response => response.json())
                  .then(cart => {
                    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
                    cartCountBubbles.forEach((bubble) => {
                      bubble.textContent = cart.item_count;
                      bubble.classList.remove('hidden');
                    });
                  });

                // Show a simple success message
                this.submitButton.setAttribute('aria-disabled', false);
                this.submitButton.classList.remove('loading');
                const spinner = this.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');

                // Temporarily change button text to show success
                const buttonText = this.submitButton.querySelector('.card__cta-text') || this.submitButtonText;
                if (buttonText) {
                  const originalText = buttonText.getAttribute('data-original-text') || 'Add to Cart';
                  buttonText.textContent = 'Added!';
                  setTimeout(() => {
                    buttonText.textContent = originalText;
                  }, 2000);
                }

                return;
              }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');

              // Show success feedback for product cards
              const buttonText = this.submitButton.querySelector('.card__cta-text') || this.submitButtonText;
              if (buttonText) {
                const originalText = buttonText.getAttribute('data-original-text') || 'Add to Cart';
                buttonText.textContent = 'Added!';
                setTimeout(() => {
                  buttonText.textContent = originalText;
                }, 2000);
              }
            }
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      async showMinimumQuantityMessage() {
        // Minimum rule is now order value (see minimum-quantity-checkout.js); delegate to it.
        if (typeof MinimumQuantityCheckout === 'undefined' || typeof MinimumQuantityCheckout.validateAllButtons !== 'function') return;
        try {
          await MinimumQuantityCheckout.validateAllButtons();
        } catch (error) {
          console.error('Error checking minimum order value:', error);
        }
      }

      updateBuyNowButtons(currentQuantity, minimumQuantity, itemsNeeded) {
        // Find the payment button container
        const paymentContainer = this.form.querySelector('.shopify-payment-button');
        if (!paymentContainer) return;

        // Wait a bit for Shopify payment buttons to load
        setTimeout(() => {
          // Find the actual Buy Now buttons (they load dynamically)
          const actualButtons = paymentContainer.querySelectorAll('.shopify-payment-button__button, [data-testid*="Checkout"]');

          // If no buttons found yet, try again
          if (actualButtons.length === 0) {
            // Payment buttons might still be loading, try again
            setTimeout(() => this.updateBuyNowButtons(currentQuantity, minimumQuantity, itemsNeeded), 500);
            return;
          }

          // Update each Buy Now button - just disable/blur without changing text
          actualButtons.forEach(button => {
            const needsDisable = currentQuantity < minimumQuantity;

            // Track current state including quantity to prevent unnecessary updates
            const currentState = button.dataset.buyNowState;
            const newState = needsDisable ? `disabled-${currentQuantity}` : 'enabled';

            // Only update if state has changed
            if (currentState !== newState) {
              button.dataset.buyNowState = newState;

              if (needsDisable) {
                // Disable and blur the button
                button.disabled = true;
                button.style.opacity = '0.5';
                button.style.cursor = 'not-allowed';
                button.style.filter = 'blur(0.5px)';
                button.style.pointerEvents = 'none';
                button.title = `Add ${itemsNeeded} more item${itemsNeeded !== 1 ? 's' : ''} to cart (minimum ${minimumQuantity} items required)`;
              } else {
                // Enable and restore button
                button.disabled = false;
                button.style.opacity = '';
                button.style.cursor = '';
                button.style.filter = '';
                button.style.pointerEvents = '';
                button.title = '';
              }
            }
          });

          // Remove any old custom buttons that might exist
          const oldCustomButton = paymentContainer.querySelector('.minimum-quantity-button');
          if (oldCustomButton) {
            oldCustomButton.remove();
          }
        }, 500); // Give payment buttons time to load
      }

      listenForCartUpdates() {
        // Listen for cart updates to refresh the message
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        // minimum-quantity-checkout.js already subscribes to cart updates and re-checks buttons,
        // so no per-form polling here (it caused a request flood with many product forms on a page).
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Don't block Add to Cart - let it always work
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Continue with original submission logic...
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Try to find cart element again after successful add
              this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

              // If still no cart drawer/notification, just update cart count in header
              if (!this.cart) {
                // Update cart count in header
                fetch('/cart.js')
                  .then(response => response.json())
                  .then(cart => {
                    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
                    cartCountBubbles.forEach((bubble) => {
                      bubble.textContent = cart.item_count;
                      bubble.classList.remove('hidden');
                    });
                  });

                // Show a simple success message
                this.submitButton.setAttribute('aria-disabled', false);
                this.submitButton.classList.remove('loading');
                const spinner = this.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');

                // Temporarily change button text to show success
                const buttonText = this.submitButton.querySelector('.card__cta-text') || this.submitButtonText;
                if (buttonText) {
                  const originalText = buttonText.getAttribute('data-original-text') || 'Add to Cart';
                  buttonText.textContent = 'Added!';
                  setTimeout(() => {
                    buttonText.textContent = originalText;
                  }, 2000);
                }

                return;
              }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');

              // Show success feedback for product cards
              const buttonText = this.submitButton.querySelector('.card__cta-text') || this.submitButtonText;
              if (buttonText) {
                const originalText = buttonText.getAttribute('data-original-text') || 'Add to Cart';
                buttonText.textContent = 'Added!';
                setTimeout(() => {
                  buttonText.textContent = originalText;
                }, 2000);
              }
            }
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }
    }
  );
}
